module.exports = __webpack_public_path__ + "static_pc/img/cos03.cdec78d3.png";